import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { AddFriendsIcon } from '../../assets';
import UserRank from './UserRank';

export interface IInviteFriendsWidgetProps {
  inviteUrl: string;
}

export const InviteFriendsWidget: React.FC<IInviteFriendsWidgetProps> = ({ inviteUrl }) => {
  const { t } = useTranslation();

  return (
    <a href={inviteUrl} className="invite-friends-widget col-2">
      <UserRank name={t('Highscore.InviteFriends')} picture={AddFriendsIcon} active={false} loading={false} />
    </a>
  );
};

export default InviteFriendsWidget;
